import React from 'react';
import { classNames } from '@panwds/tailwindcss';

/* istanbul ignore next */
const SubTabPanel = ({ activeSubTabId = null, addClassName, children, dataMetrics, dataTestId, forSubTabId, hideInactiveTabs = false }) => {
    const active = activeSubTabId === null || activeSubTabId === forSubTabId;
    const className = classNames('tw-outline-none tw-ml-4 tw-mt-4', addClassName, !active && 'tw-hidden');
    if (!active && !hideInactiveTabs)
        return null;
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || `subtab-panel-${forSubTabId}`, className: className, "aria-labelledby": forSubTabId, "aria-expanded": active, role: "tabpanel", tabIndex: active ? 0 : -1 }, children));
};

export { SubTabPanel };
//# sourceMappingURL=SubTabPanel.esm.js.map
